import React, {type FC} from 'react';
import moment, {type Moment} from 'moment';
import {DATE_PICKER_STYLE} from '../../../constants';
import DatePicker from '../../shared/components/date-picker/date_picker_v3';

/** Person fields used by the resources table date cells (strings from GraphQL; null when cleared). */
export type PeoplePersonDateCellPerson = {
	startDate: string | null;
	endDate: string | null;
};

export type PeoplePersonDateChangeHandler = (value: Moment | null) => void;

type PeoplePersonDateCellProps = {
	person: PeoplePersonDateCellPerson;
	onDateChange: PeoplePersonDateChangeHandler;
};

export const StartDate: FC<PeoplePersonDateCellProps> = ({person, onDateChange}) => (
	<td className="date-width">
		<DatePicker
			startDate={person.startDate ? moment(person.startDate) : null}
			handleDateRangeChange={value => onDateChange(value)}
			clearBothDates={() => onDateChange(null)}
			datePickerStyle={DATE_PICKER_STYLE.SLIM}
			isSingleDatePicker
			clearable
			endDateLimite={person.endDate ? moment(person.endDate).add(1, 'days') : null}
			hideLimitMessage
			startDateEmptyText="-"
		/>
	</td>
);

export const EndDate: FC<PeoplePersonDateCellProps> = ({person, onDateChange}) => (
	<td className="date-width">
		<DatePicker
			startDate={person.endDate ? moment(person.endDate) : null}
			handleDateRangeChange={value => onDateChange(value)}
			clearBothDates={() => onDateChange(null)}
			datePickerStyle={DATE_PICKER_STYLE.SLIM}
			isSingleDatePicker
			clearable
			startDateLimite={person.startDate ? moment(person.startDate) : null}
			hideLimitMessage
			startDateEmptyText="-"
		/>
	</td>
);
